import { Chip, Stack, Tooltip } from '@mui/material';
import {
  loadingSessionStatusInfo,
  msDemandStatusInfo,
  palletStatusInfo,
  pickingJobStatusInfo,
  sessionLinkStatusInfo,
  shipmentErrorChipInfo,
  statusChipSx,
} from '../../pages/fulfillmentUi.mjs';

const RESOLVERS = {
  pallet: palletStatusInfo,
  loadingSession: loadingSessionStatusInfo,
  pickingJob: pickingJobStatusInfo,
  sessionLink: sessionLinkStatusInfo,
  msDemand: msDemandStatusInfo,
};

/**
 * Цветной Chip статуса Fulfillment (тот же стиль, что у заказов).
 * kind: pallet | loadingSession | pickingJob | sessionLink | msDemand
 * Для произвольного кода — передать code + label.
 */
export default function FulfillmentStatusChip({
  kind,
  status,
  code,
  label,
  size = 'small',
  shipmentError = null,
  showShipmentError = true,
}) {
  const resolved = kind && RESOLVERS[kind]
    ? RESOLVERS[kind](status)
    : {
      code: code || status || 'unknown',
      label: label || status || 'Статус',
      sx: statusChipSx(code || status),
    };

  const errorChip = showShipmentError && shipmentError
    ? shipmentErrorChipInfo()
    : null;

  return (
    <Stack direction="row" spacing={0.75} alignItems="center" useFlexGap flexWrap="wrap">
      <Chip size={size} label={resolved.label} sx={resolved.sx} />
      {errorChip && (
        <Tooltip title={String(shipmentError)} arrow>
          <Chip size={size} label={errorChip.label} sx={errorChip.sx} />
        </Tooltip>
      )}
    </Stack>
  );
}
